import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  static values = {
    persisted: Boolean,
    initial: String
  }

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasInputTarget || !this.hasButtonTarget) return

    const inputValue = this.normalize(this.inputTarget.value)
    const initialValue = this.normalize(this.initialValue)
    const changed = inputValue !== initialValue
    const showButton = !this.persistedValue || changed

    this.buttonTarget.classList.toggle("hidden", !showButton)
    this.buttonTarget.disabled = !showButton
  }

  normalize(value) {
    return (value || "").trim()
  }
}
